import { TRegionKey } from '@source/interface';

interface IMobileNumberForm {
  label?: string;
  pattern?: RegExp;
  patternMessage?: string;
  requiredMessage?: string;
  placeholder?: string;
}

const NOTIFY_ME_PHONE_VALIDATION: Record<TRegionKey, IMobileNumberForm> = {
  sg: {
    label: 'details.notifyMe.mobileNumber.sg.label',
    pattern: /^[89]\d{7}$/g,
    patternMessage: 'details.notifyMe.mobileNumber.sg.patternMessage',
    requiredMessage: 'details.notifyMe.mobileNumber.sg.requiredMessage',
    placeholder: 'details.notifyMe.mobileNumber.sg.placeholder.sg',
  },
  th: {
    label: 'details.notifyMe.mobileNumber.th.label',
    pattern: /^[0][6|8|9]\d{8}$/g,
    patternMessage: 'details.notifyMe.mobileNumber.th.patternMessage',
    requiredMessage: 'details.notifyMe.mobileNumber.th.requiredMessage',
    placeholder: 'details.notifyMe.mobileNumber.th.placeholder.th',
  },
  id: {
    label: 'details.notifyMe.mobileNumber.id.label',
    pattern: /^(\+62|0)8[0-9]{8,11}$/g,
    patternMessage: 'details.notifyMe.mobileNumber.id.patternMessage',
    requiredMessage: 'details.notifyMe.mobileNumber.id.requiredMessage',
    placeholder: 'details.notifyMe.mobileNumber.id.placeholder.id',
  },
  my: {
    label: 'details.notifyMe.mobileNumber.my.label',
    pattern: /^((0|\+60)|60)[0-9]{9,10}$/g,
    patternMessage: 'details.notifyMe.mobileNumber.my.patternMessage',
    requiredMessage: 'details.notifyMe.mobileNumber.my.requiredMessage',
    placeholder: 'details.notifyMe.mobileNumber.my.placeholder.my',
  },
  jp: {
    label: 'details.notifyMe.mobileNumber.tw.label',
    pattern: /((?=(09))[0-9]{10})$/g,
    patternMessage: 'details.notifyMe.mobileNumber.tw.patternMessage',
    requiredMessage: 'details.notifyMe.mobileNumber.tw.requiredMessage',
    placeholder: 'details.notifyMe.mobileNumber.tw.placeholder.tw',
  },
  hk: {
    label: 'details.notifyMe.mobileNumber.hk.label',
    pattern: /^(\+?852-?)?\d{4}-?\d{4}$/g,
    patternMessage: 'details.notifyMe.mobileNumber.hk.patternMessage',
    requiredMessage: 'details.notifyMe.mobileNumber.hk.requiredMessage',
    placeholder: 'details.notifyMe.mobileNumber.hk.placeholder.hk',
  },
};

const getConfigNotifyMePhoneForm = (region: TRegionKey, t: any) => ({
  formItemProps: {
    name: 'phone',
    label: t(NOTIFY_ME_PHONE_VALIDATION?.[region]?.label) || 'Mobile Number',
    rules: [
      {
        pattern: NOTIFY_ME_PHONE_VALIDATION?.[region]?.pattern || /^[89]\d{7}$/g,
        message: t(NOTIFY_ME_PHONE_VALIDATION?.[region]?.patternMessage) || 'Please enter a valid mobile number',
      },
      {
        required: true,
        message: t(NOTIFY_ME_PHONE_VALIDATION?.[region]?.requiredMessage) || 'Please enter a valid mobile number',
      },
    ],
  },
  controlProps: {
    size: 'large',
    placeholder: t(NOTIFY_ME_PHONE_VALIDATION?.[region]?.placeholder) || 'E.g. 9123 4567',
  },
});

export const NOTIFY_ME_TICKET_CONTEXT: Record<TRegionKey, string> = {
  sg: 'buy-hunt-carro-web-sg',
  id: 'buy-hunt-carro-web-id',
  th: 'buy-hunt-carro-web-th',
  my: 'buy-hunt-mytukar-web-my',
  jp: 'buy-hunt-carro-web-jp', // todo: check jp buy-hunt key
  hk: 'buy-hunt-carro-web-hk', // todo: check hk buy-hunt key
};
export default getConfigNotifyMePhoneForm;
